import { Avatar, Stack, Text, ThemeIcon, Tooltip } from "@mantine/core";
import { useFlowStore } from "../../../../../../stores/WorkflowStore";
import {
  IconMessage,
  IconMessageFilled,
  IconUserCircle,
} from "@tabler/icons-react";
import ModelLinkedinSelector from "../../../../../../components/Selectors/ModelLinkedinSelector";
import LinkedinAccountSelector from "../../../../../../components/Selectors/LinkedinAccountSelector";
import { useLanguage } from "../../../../../../stores/LanguageStore";
import account_placeholder from "../../../../../../assets/icons/account_placeholder.png";

const LinkedinNodeBody = ({ node_id, data, xPos, yPos }) => {
  const lang = useLanguage((s) => s.language);
  const updateNodeData = useFlowStore((s) => s.updateNodeData);
  const handleModelChange = (v) => {
    const newValue = v?.id ? parseInt(v?.id) : null;
    updateNodeData(node_id, {
      model_id: newValue,
    });
  };
  const handleSenderChange = (v) => {
    let isPool = v?.number_of_accounts !== undefined;
    const newValue = v?.id ? parseInt(v?.id) : null;
    updateNodeData(node_id, {
      [isPool ? "pool_id" : "integration_id"]: newValue,
      [isPool ? "integration_id" : "pool_id"]: null,
    });
  };

  return (
    <Stack w={"100%"} pb={6} gap={"xs"} bg={"#fff"}>
      {data?.actionType !== "linkedin_visit" && (
        <ModelLinkedinSelector
          className="nodrag nopan"
          value={data?.model_id}
          onChange={handleModelChange}
          // onClick={() => handleNoValueClick(data?.model_id)}
          required={data?.actionType !== "linkedin_invitation"}
          size={"sm"}
          type={data?.actionType}
          vocalOnly={data?.actionType === "linkedin_vocal"}
          leftSection={
            <Tooltip label={lang.campaign.selectors.email.tooltip}>
              <ThemeIcon>
                <IconMessageFilled size={16} strokeWidth={1.5} />
              </ThemeIcon>
            </Tooltip>
          }
          variant="contained"
          placeholder={lang.workflows.nodes.model}
          styles={{
            input: {
              background: "#f2eaff96",
            },
          }}
        />
      )}
      {data?.actionType !== "sms" && (
        <LinkedinAccountSelector
          className="nodrag nopan"
          value={data?.pool_id || data?.integration_id}
          onChange={handleSenderChange}
          // onClick={() =>
          //   handleNoValueClick(data?.pool_id || data?.integration_id)
          // }
          required
          placeholder={lang.workflows.nodes.account}
          size={"sm"}
          leftSection={
            <Tooltip label={lang.campaign.selectors.senders.tooltip_linkedin}>
              <Avatar src={account_placeholder} size={20} />
            </Tooltip>
          }
          width={300}
          other={{
            variant: "contained",
            leftSectionWidth: 36,
            radius: "lg",
            styles: {
              input: {
                background: "#f2eaff96",
              },
            },
          }}
        />
      )}
      {data?.actionType === "linkedin_message" && (
        <Text size="xs" c={"dimmed"}>
          {lang.campaign.selectors.senders.linkedin_message_info}
        </Text>
      )}
    </Stack>
  );
};

export default LinkedinNodeBody;
